import React from 'react'

const CommentIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="commentGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(120, 200, 255, 1)" />
          <stop offset="100%" stopColor="rgba(80, 160, 220, 1)" />
        </linearGradient>
        <filter id="commentGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Comment bubble */}
      <path 
        d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2z"
        fill="url(#commentGradient)"
        filter="url(#commentGlow)"
      />
      
      {/* Text lines inside bubble */}
      <line 
        x1="7" 
        y1="8" 
        x2="17" 
        y2="8" 
        stroke="rgba(255, 255, 255, 0.7)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line 
        x1="7" 
        y1="12" 
        x2="14" 
        y2="12" 
        stroke="rgba(255, 255, 255, 0.7)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default CommentIcon
